import React, { useRef, useEffect, useState } from 'react'
import HomeHeader from '../../components/HomeComponent/HomeHeader'
import { getAllRecipesApi } from '../../api/recipe.api';
import HomeBody from '../../components/HomeComponent/HomeBody';

const HomeContainer = () => {
    const [recipes, setRecipes] = useState([]);
    const [search, setSearch] = useState('');
    const [totalPage, setTotalPage] = useState(0);
    const [pageId, setPageId] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(9);
    const ref = useRef(null);
    const [width, setWidth] = useState(window.innerWidth);

    const handleClickToScroll = () => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }

    function getAllRecipesForShow() {
        getAllRecipesApi(search, pageId, itemsPerPage)
            .then(res => {
                setRecipes(res.data.content);
                setTotalPage(res.data.totalPages)
            })
            .catch()
    };

    const handlePageClick = (event) => {
        setPageId(event.selected + 1);
        handleClickToScroll();
    }

    useEffect(() => {
        window.addEventListener("resize", (event) => {
            let currentWidth = event.target.innerWidth;
            while (currentWidth <= 430) {
                setWidth(430);
                break;
            }
            while (currentWidth > 430) {
                setWidth(431);
                break;
            }
        })
    })

    useEffect(() => {
        if(window.innerWidth < 430){
            setItemsPerPage(8);
        }
        setItemsPerPage(width <= 430 ? 8 : 9);
    }, [width])

    useEffect(() => {
        setPageId(1);
        getAllRecipesForShow();
    }, [search, itemsPerPage])

    useEffect(() => {
        getAllRecipesForShow();
    }, [pageId])

    return (
        <>
            <HomeHeader
                handleClickToScroll={handleClickToScroll}
            />
            <HomeBody
                handlePageClick={handlePageClick}
                recipes={recipes}
                search={search}
                setSearch={setSearch}
                totalPage={totalPage}
                ref={ref}
            />
        </>
    )
}

export default HomeContainer